export const apiUrl = process.env.VUE_APP_S3_API_URL;
export const geoJsonUrl = process.env.VUE_APP_GEOJSON_URL;
export const storageKey = "election_embeds__v3_7";
